/* eslint-disable react/button-has-type */
import React from 'react';
import { useNavigate } from 'react-router-dom';
import logo from '../../Assets/elvotaimages/logo.png';

export default function FooterTop() {
  const navigate = useNavigate(); // Initialize the useNavigate hook

  return (
    <div className="footer-bg">
      <div
        className="main-container"
        style={{ paddingTop: '70px', paddingBottom: '70px' }}
      >
        <div className="grid grid-cols-12 items-start text-white">
          <div className="col-span-12 sm:col-span-6 sm:border-r sm:border-gray-300">
            {/* First Container */}
            <div className="pt-4 pb-4">
              <div className="grid grid-cols-12 items-start gap-y-[40px]">
                <div className="col-span-12 sm:col-span-6">
                  {/* Add bottom padding to the heading */}
                  <h2 className="text-lg font-semibold pb-4 footer-heading-font">
                    Where to Find Us
                  </h2>
                </div>
              </div>
              {/* Add gap-y-[40px] to create 40px gap between rows */}
              <div className="grid grid-cols-12 items-start gap-y-[40px]">
                <div className="col-span-12 sm:col-span-6">
                  <div className="grid grid-cols-12 items-start gap-y-[40px] pr-1">
                    {/* 40px gap here */}
                    <div className="col-span-12 footer-font">
                      Evolta Technologies SA,
                      <br />
                      EPFL Innovation Park, Building C
                      <br />
                      1015 Lausanne, CH
                    </div>

                    <div className="col-span-12 hidden sm:block">
                      <img
                        src={logo}
                        alt="Logo"
                        className="block w-auto h-auto" // Maintain aspect ratio
                        style={{
                          height: '32px', // Maintain natural aspect ratio
                          objectFit: 'contain', // Ensures the image fits within its container
                        }}
                      />
                    </div>
                  </div>
                </div>
                <div className="col-span-12 sm:col-span-6 footer-font pr-1">
                  Evolta Technologies Corporation
                  <br />
                  108 Lakeland Avenue 19901 Dover, <br />
                  Delaware, US
                </div>
              </div>
            </div>
          </div>
          <div className="col-span-12 sm:col-span-6">
            <div className="grid grid-cols-12 items-start gap-y-[50px]">
              <div className="col-span-12">
                {/* Second Container */}
                <div className="pt-4 pb-4 sm:pl-[25%]">
                  <div className="grid grid-cols-12 items-start gap-y-[50px]">
                    <div className="col-span-12 ">
                      {/* Add bottom padding to the heading */}
                      <h2 className="text-lg font-semibold pb-4 footer-heading-font">
                        Get In Touch
                      </h2>
                    </div>
                  </div>
                  {/* Add gap-y-[40px] to create 40px gap between rows */}
                  <div className="grid grid-cols-12 items-start gap-y-[40px]">
                    <div className="col-span-12 footer-font">
                      Interested in optimizing your energy returns?
                    </div>
                    <div className="col-span-12">
                      <button
                        className="w-[116px] h-[41px] bg-green hover:bg-black-light hover:text-white transition-colors duration-500 rounded-[20px] f-f-sm text-sm text-black-light mt-5 footer-font"
                        onClick={() =>
                          navigate('/contact-us#evolta_contact_form')
                        }
                      >
                        Contact Us
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
